export default "__VITE_ASSET__DPu3kc79__"